module.exports = __webpack_public_path__ + "static/media/regan.cc36c8bd.jpg";